import './App.css'

import React from 'react';

import MainPage from './components/MainPage';
import Payment from './components/Payment';
import Session from './components/Payment/Session';
import Suppliers from './components/Suppliers';
import Locations from './components/Locations';
import PurchaseOrders from './components/PurchaseOrders';
import Orders from './components/Orders';
import Assignments from './components/Assignments';
import WarehouseReceivingOrders from './components/WarehouseReceivingOrders';

import ArchivedIndex from './components/PurchaseOrders/ArchivedIndex';
import RejectedIndex from './components/PurchaseOrders/RejectedIndex';

import NewSupplierForm from './components/Suppliers/NewSupplierForm';
import EditSupplierForm from './components/Suppliers/EditSupplierForm';

import NewPurchaseOrderForm from './components/PurchaseOrders/NewPurchaseOrderForm';
import NewDropshipPurchaseOrderForm from './components/PurchaseOrders/NewDropshipPurchaseOrderForm';
import NewSuggestedPurchaseOrderForm from './components/PurchaseOrders/NewSuggestedPurchaseOrderForm';
import EditPurchaseOrderForm from './components/PurchaseOrders/EditPurchaseOrderForm';
import CopyPurchaseOrderForm from './components/PurchaseOrders/CopyPurchaseOrderForm';
import UpdateShipments from './components/PurchaseOrders/UpdateShipments';

import NewReceivingOrderForm from './components/WarehouseReceivingOrders/NewReceivingOrderForm';

import Settings from './components/Settings';

import SuggestedPurchaseOrders from './components/SuggestedPurchaseOrders';
import Suggestions from './components/SuggestedPurchaseOrders/Suggestions';
import Thresholds from './components/SuggestedPurchaseOrders/Thresholds';

import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';

import '@shoelace-style/shoelace/dist/themes/light.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path';

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.19.0/cdn/');

const App = ({ payload, checkoutSessionId }) => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path='/' element={<MainPage payload={payload} checkoutSessionId={checkoutSessionId} />} />
          <Route path='/payment' element={<Payment payload={payload} />} />
          <Route path='/payment_session/:checkoutSessionId' element={<Session payload={payload} />} />
          <Route path='/suppliers' element={<Suppliers payload={payload} />} />
          <Route path='/supplier/new' element={<NewSupplierForm payload={payload} />} />
          <Route path='/supplier/edit/:id' element={<EditSupplierForm payload={payload} />} />

          <Route path='/locations' element={<Locations payload={payload} />} />

          <Route path='/orders' element={<Orders payload={payload} />} />

          <Route path='/purchase_orders' element={<PurchaseOrders payload={payload} />} />
          <Route path='/purchase_orders/archived' element={<ArchivedIndex payload={payload} />} />
          <Route path='/purchase_orders/rejected' element={<RejectedIndex payload={payload} />} />
          <Route path='/purchase_order/new' element={<NewPurchaseOrderForm payload={payload} />} />
          <Route path='/purchase_order/dropship/:orderId' element={<NewDropshipPurchaseOrderForm payload={payload} />} />
          <Route path='/purchase_order/suggestion/:suggestedOrderId' element={<NewSuggestedPurchaseOrderForm payload={payload} />} />
          <Route path='/purchase_order/edit/:id' element={<EditPurchaseOrderForm payload={payload} />} />
          <Route path='/purchase_order/shipments/:id' element={<UpdateShipments payload={payload} />} />
          <Route path='/purchase_order/copy/:id' element={<CopyPurchaseOrderForm payload={payload} />} />

          <Route path='/purchase_order/receive/:id' element={<NewReceivingOrderForm payload={payload} />} />

          <Route path='/warehouse_receiving_orders/purchase_order/:id' element={<WarehouseReceivingOrders payload={payload} />} />

          <Route path='/suggest' element={<SuggestedPurchaseOrders payload={payload} />} />
          <Route path='/generate_suggestions' element={<Suggestions payload={payload} />} />
          <Route path='/thresholds' element={<Thresholds payload={payload} />} />

          <Route path='/assignments' element={<Assignments payload={payload} />} />

          <Route path='/settings' element={<Settings payload={payload} />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App;
